<template>
    <structure>
        <router-view/>
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    export default {
        name: 'login',
        components: { structure },
        methods: {
            goTo(page){
                this.$router.push({ path: page })
            },
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
